import "./css/App.css";

import { Routes, Route, useLocation } from "react-router-dom";
import React, { useEffect } from "react";

import LandingPage from "./pages/landing.js";
import KoffersMap from "./pages/koffersMap.js";
import Camp5g from "./pages/5gCamp.js";
import QIncidentsNl from "./pages/qIncidentsNl.js";
import QIncidentsDe from "./pages/qIncidentsDe.js";

import InvoicingOverview from "./pages/invoicing/overview.js";
import InvoiceDetails from "./pages/invoicing/invoiceDetails.js";
import InvoicingNewInvoices from "./pages/invoicing/newInvoices.js";
import InvoicingContractsOverview from "./pages/invoicing/contractsOverview.js";

import SupportTickets from "./pages/support/tickets.js";
import SupportSignalTest from "./pages/support/signalTest.js";
import SupportTerminal from "./pages/support/terminal.js";

import ServicesOverview from "./pages/services/overview";
import ServicesContacts from "./pages/services/contacts";
import ServicesKoffers from "./pages/services/koffers";
import ServicesOveruse from "./pages/services/overuse";
import ServiceDetails from "./pages/services/details.js";
import ServiceUsage from "./pages/services/usage.js";

import OrdersOverview from "./pages/orders/overview";
import OrdersDirtyOrders from "./pages/orders/dirtyOrders";

import AssetsDevices from "./pages/assets/devices";
import AssetsAddDevices from "./pages/assets/addDevices";
import AssetsUpdateDevices from "./pages/assets/updateDevices";
import AssetsSims from "./pages/assets/sims";
import AssetsAddSims from "./pages/assets/addSims";
import AssetsUpdateSims from "./pages/assets/updateSims";
import AssetsInventoryCheck from "./pages/assets/inventoryCheck.js";

import LogsTables from "./pages/admin/logsTables";
import PoolsDataUsage from "./pages/admin/poolsDataUsage";
import PoolDataUsageDetails from "./pages/admin/poolDataUsageDetails";
import HardwareDetails from "./pages/assets/hardwareDetails";
import SimcardDetails from "./pages/assets/simcardDetails";
import PSQLEdit from "./pages/admin/PSQL edit";

import Navbar from "./components/navbar";
// import Navbar from "./components/navbar2";

function App() {
  useEffect(() => {
    document.title = "Geuzenet";
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        {["/kf", "/camp", "/qIncidentsNl", "/qIncidentsDe"].includes(
          useLocation().pathname
        ) ? (
          ""
        ) : (
          <div className="navGclass">
            <Navbar />
          </div>
        )}
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route exact path="/kf" element={<KoffersMap />} />{" "}
          <Route exact path="/camp" element={<Camp5g />} />
          <Route exact path="/qIncidentsNl" element={<QIncidentsNl />} />
          <Route exact path="/qIncidentsDe" element={<QIncidentsDe />} />
          <Route
            exact
            path="/InvoicingNew Invoices"
            element={<InvoicingNewInvoices />}
          />
          <Route
            exact
            path="/InvoicingOverview"
            element={<InvoicingOverview />}
          />
          <Route
            exact
            path="/InvoiceDetails/:invoice"
            element={<InvoiceDetails />}
          />
          <Route
            exact
            path="/InvoicingContracts/:contract?"
            element={<InvoicingContractsOverview />}
          />
          <Route exact path="/SupportTickets" element={<SupportTickets />} />
          <Route
            exact
            path="/SupportSignal test/:tag?"
            element={<SupportSignalTest />}
          />
          <Route exact path="/SupportTerminal" element={<SupportTerminal />} />
          <Route
            exact
            path="/ServicesOverview"
            element={<ServicesOverview />}
          />
          <Route
            exact
            path="/ServicesContacts"
            element={<ServicesContacts />}
          />
          <Route exact path="/ServicesKoffers" element={<ServicesKoffers />} />
          <Route exact path="/ServicesOveruse" element={<ServicesOveruse />} />
          <Route path="/serviceDetails/:id" element={<ServiceDetails />} />
          <Route path="/serviceUsage/:id" element={<ServiceUsage />} />
          <Route exact path="/OrdersOverview" element={<OrdersOverview />} />
          <Route
            exact
            path="/OrdersDirty orders"
            element={<OrdersDirtyOrders />}
          />
          <Route exact path="/AssetsDevices" element={<AssetsDevices />} />
          <Route
            exact
            path="/AssetsAdd devices"
            element={<AssetsAddDevices />}
          />
          <Route
            exact
            path="/AssetsUpdate devices"
            element={<AssetsUpdateDevices />}
          />
          <Route exact path="/AssetsSims" element={<AssetsSims />} />
          <Route exact path="/AssetsAdd sims" element={<AssetsAddSims />} />
          <Route
            exact
            path="/AssetsUpdate sims"
            element={<AssetsUpdateSims />}
          />
          <Route
            exact
            path="/AssetsInventory check"
            element={<AssetsInventoryCheck />}
          />
          <Route path="/hardwareDetails/:tag" element={<HardwareDetails />} />
          <Route path="/simcardsDetails/:tag" element={<SimcardDetails />} />
          <Route exact path="/AdminLogs tables" element={<LogsTables />} />
          <Route exact path="/AdminPools usage" element={<PoolsDataUsage />} />
          <Route exact path="/AdminPSQL edit" element={<PSQLEdit />} />
          <Route
            path="/poolUsageDetails/:id"
            element={<PoolDataUsageDetails />}
          />
        </Routes>
      </header>
      {/* <footer style={{ color: "blue", lineHeight: 10, padding: 20 }}></footer> */}
    </div>
  );
}

export default App;
